import { initializeApp } from 'firebase/app'
import { getFirestore, collection, query, where, getDocs, Timestamp, updateDoc, serverTimestamp, doc, addDoc, setDoc, getDoc, deleteDoc, orderBy, onSnapshot } from 'firebase/firestore'
import { getAuth, onAuthStateChanged, signInAnonymously, signInWithEmailAndPassword, updateProfile, createUserWithEmailAndPassword } from 'firebase/auth'
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage'
import { getFunctions, httpsCallable } from 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyBFDsWr3JF0cVuCks6oGFPJvZsTOnYalZo',
  authDomain: 'amazing-grace-sc.firebaseapp.com',
  databaseURL: 'https://amazing-grace-sc.firebaseio.com',
  projectId: 'amazing-grace-sc',
  storageBucket: 'amazing-grace-sc.appspot.com',
  messagingSenderId: '322880606691',
  appId: '1:322880606691:web:03775b47d28b51e0d950d6',
  measurementId: 'G-E2QK3P3ZNS'
}

// init firebase
const firebaseApp = initializeApp(firebaseConfig)
// init firebase functions
const functions = getFunctions(firebaseApp)
// init firestore servicee
const db = getFirestore(firebaseApp)
// Auth
const auth = getAuth(firebaseApp)
// Get a reference to the storage service, which is used to create references in your storage bucket
const storage = getStorage(firebaseApp)

// export firestore
export {
  db, auth, setDoc, addDoc, createUserWithEmailAndPassword, ref, uploadBytesResumable, getDownloadURL, signInAnonymously,
  storage, collection, query, deleteDoc, serverTimestamp, httpsCallable,
  where, getDocs, onAuthStateChanged, Timestamp, functions, uploadBytes, deleteObject,
  signInWithEmailAndPassword, doc, getDoc, orderBy, updateProfile, updateDoc, onSnapshot
}
